import { createSelector, createSlice } from "@reduxjs/toolkit";

const initialState = {
  informationModal: []
};

const generalSlice = createSlice({
  name: "generalSlice",
  initialState,
  reducers: {
    updateInformationModal: (state, action) => {
      state.informationModal = [...state.informationModal, action.payload];
    }
  }
});

export default generalSlice.reducer;

export const { updateInformationModal } = generalSlice.actions;

export const getInformationModal = (key) =>
  createSelector(
    (state) => state.generalSlice,
    (generalSlice) => generalSlice.informationModal?.includes(key)
  );
